import React, { Component } from 'react';
import { BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Card, Button } from 'reactstrap';
import { BREAKUP_OF_BUSINESS_TYPE, BREAKUP_OF_BUSINESS_TYPE_DESCRIPTION } from '../constants';

class BusinessBrekupBarChartComponent extends Component {

  state = {
    barChartProperties: { with_me_color: '', with_cug_member: '', cug_group_color: '' },
    selectedfilter: undefined,
    filterdData : []
  }

  componentDidMount() {
    if (this.props.chartData) {
      this.setState({ chartData: this.props.chartData })
    } else {
    }
  }

  handleTypeFilter = (e) => {
    if (this.state.selectedfilter !== e.target.value) {
      this.setState({ selectedfilter: e.target.value }, ()=>{
        this.filterData(this.state.selectedfilter);
      })
    }
    e.preventDefault();
  }

  filterData = (monthYear) => {
    let filterdData = [];
    let data = {};
    let data1 = {};
    this.props.chartData.forEach(element => {
      if (element.type === "WITH_ME" && element.month == monthYear) {
        data = { ...data, ...element }
      } else if (element.type === "WITH_OTHERS" && element.month == monthYear) {
        data1 = { ...data1, ...element }
      }
    });
    filterdData.push(data);
    filterdData.push(data1);
    this.setState({ filterdData: filterdData })
  }

  componentDidUpdate( prevProps ) {
    if(this.props.chartData !== prevProps.chartData){
      this.setState({ selectedfilter :this.props.monthfilters[0] }, ()=>{
        this.filterData(this.props.monthfilters[0]);
      })
    }
  }

  render() {
    return (
        <Card body className='mt-3' >
          <div>
            <h3 className='text-center'>
              {BREAKUP_OF_BUSINESS_TYPE}
            </h3>

            {
              this.props.monthfilters 
              && this.props.monthfilters.length > 0 
              && <select className='position-absolute chart-filter-dropdown' name="typefilter" onChange={(e) => this.handleTypeFilter(e)}  value= {this.state.selectedfilter}>
                {this.props.monthfilters.map(optionValue => (<option value={optionValue} key={Math.random()} >{optionValue}</option>))}
              </select>
            }
          </div>
          <ResponsiveContainer width='100%' height={300}>
            <BarChart
              data={this.state.filterdData}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}  >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend style={{ marginTop: `5px !important` }} />
              <Bar dataKey="JEWELRY_SALE" fill="#5B9BD5" name='Finished jewelry sale' stackId='a' />
              <Bar dataKey="DIAMOND_SALES" fill="#A5A5A5" name='Loose diamond sale' stackId='a' />
              <Bar dataKey="JOB_WORK" fill="#ED7D31" name='Job work' stackId='a' />
            </BarChart>
          </ResponsiveContainer>
          
          <details>
              <summary>
                  <i>Know more...</i>
              </summary>
              <p dangerouslySetInnerHTML={{ __html: BREAKUP_OF_BUSINESS_TYPE_DESCRIPTION }}></p>
          </details>

        </Card>
    );
  }
}

export default BusinessBrekupBarChartComponent;